
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "createPaywallTemplateV2",
      resolverType: "mutation",
      routePath: "/createPaywallTemplateV2",
      httpMethod: "POST",
    });
  